import { useQuery } from '@tanstack/react-query';
import { useApi } from '@mainstage/core-plugin-api';
import { featureRequestRequesterApiRef } from '../../apis';
import { ReceivedFeatureRequestFilters } from '@agilelab/plugin-wb-builder-common';

export const useFeatureRequestsReceived = (
  filters: ReceivedFeatureRequestFilters,
) => {
  const api = useApi(featureRequestRequesterApiRef);

  return useQuery({
    queryKey: ['feature-requests', 'received', filters],
    queryFn: () => api.fetchReceived(filters),
    staleTime: 5 * 60 * 1000,
  });
};
